import { useMutation } from '@tanstack/react-query';
import { antibotKeys } from './antibot.keys';
import { verifyHumanity } from './antibot.service';
export const useVerifyHumanity = () => {
    return useMutation({
        mutationKey: antibotKeys.verifyHumanity(),
        mutationFn: verifyHumanity,
    });
};
